import React from 'react';
import bem from '../../../_utils/bem';
import PropTypes from 'prop-types';

var MenuIcon = function MenuIcon(_ref) {
  var block = _ref.block,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'icon' : _ref$element,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers;
  return /*#__PURE__*/React.createElement("svg", {
    className: bem(block, element, modifiers),
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6h28v6H2zm0 8h28v6H2zm0 8h28v6H2z"
  }));
};

MenuIcon.prototype = {
  block: PropTypes.string,
  element: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string)
};
export default MenuIcon;